import * as yup from 'yup';
import { JobRoleType, UserEmploymentStatusType } from '../types';

export const createUserDialogSchema = yup.object({}).shape({
  firstName: yup.string().label('First Name'),
  lastName: yup.string().label('Last Name'),
  email: yup
    .string()
    .email()
    .test(
      'is-valid-email',
      'Email is required', // Error message
      function (value) {
        const { contactType } = this.parent; // Accessing the value of contactType
        if (contactType) {
          return true; // Pass the validation when contactType is true (password can be empty)
        }
        return !!value; // Otherwise, enforce password length of 8 characters
      }
    )
    .label('Email'),
  mobilePhone: yup.string().label('Phone'),
  contactType: yup.boolean().required().label('Contact Only / No Dashboard Access'),
  temporaryPassword: yup
    .string()
    .test(
      'is-valid-password',
      'Temporary password is required and must be at least 8 characters', // Error message
      function (value) {
        const { contactType } = this.parent; // Accessing the value of contactType
        if (contactType) {
          return true; // Pass the validation when contactType is true (password can be empty)
        }
        return !!value && value.length >= 8; // Otherwise, enforce password length of 8 characters
      }
    )
    .label('Temporary password'),
  jobRole: yup.mixed<JobRoleType>().oneOf(Object.values(JobRoleType)).nullable().label('Job role'),
  employmentStatus: yup
    .mixed<UserEmploymentStatusType>()
    .oneOf(Object.values(UserEmploymentStatusType))
    .nullable()
    .label('Employment status'),
  roleIds: yup.array().of(yup.string().required()).label('Roles'),
  venueIds: yup.array().of(yup.string().required()).label('Venues'),
  clientIds: yup.array().of(yup.string().required()).label('Clients'),
  clientId: yup.string().label('clientId'),
  userSubscriptionIds: yup.array().of(yup.string().required()).label('User Subscriptions'),
  userNotificationIds: yup.array().of(yup.string().required()).label('User Notifications')
});

export const updateUserDialogSchema = yup.object().shape({
  firstName: yup.string().required().label('First Name'),
  lastName: yup.string().required().label('Last Name'),
  mobilePhone: yup.string().label('Phone'),
  jobRole: yup.mixed<JobRoleType>().oneOf(Object.values(JobRoleType)).nullable().label('Job role'),
  employmentStatus: yup
    .mixed<UserEmploymentStatusType>()
    .oneOf(Object.values(UserEmploymentStatusType))
    .nullable()
    .label('Employment status'),
  roleIds: yup.array().of(yup.string().required()).label('Roles'),
  venueIds: yup.array().of(yup.string().required()).label('Venues'),
  clientIds: yup.array().of(yup.string().required()).label('Clients'),
  clientId: yup.string().label('clientId'),
  userSubscriptionIds: yup.array().of(yup.string().required()).label('User Subscriptions'),
  userNotificationIds: yup.array().of(yup.string().required()).label('User Notifications')
});

export const changeUserPasswordDialogSchema = yup.object().shape({
  newPassword: yup
    .string()
    .test('password-length-test', 'Password must be at least 8 characters!', (value) => {
      return !value || value.length === 0 || value.length >= 8;
    })
    .required()
    .label('New Password'),
  confirmPassword: yup
    .string()
    .test('password-length-test', 'Password must be at least 8 characters!', (value) => {
      return !value || value.length === 0 || value.length >= 8;
    })
    .required()
    .label('Confirm Password')
    .oneOf([yup.ref('newPassword')], 'Your passwords do not match.')
});

export const changePasswordDialogSchema = yup.object().shape({
  oldPassword: yup.string().required().label('Old Password'),
  newPassword: yup.string().required().label('New Password'),
  confirmPassword: yup
    .string()
    .required()
    .label('Confirm Password')
    .oneOf([yup.ref('newPassword')], 'Your passwords do not match.')
});

export const userSignInSchema = yup.object().shape({
  email: yup.string().required().label('Email address')
});

export const signInCodeSchema = yup.object().shape({
  code: yup.string().required().label('Code')
});

export const forcePasswordSchema = yup.object().shape({
  customPassword: yup.string().required().label('New password'),
  confirmCustomPassword: yup
    .string()
    .required()
    .label('Confirm new Password')
    .oneOf([yup.ref('customPassword')], 'Your passwords do not match.')
});

export const forgotPasswordEmailSchema = yup.object().shape({
  email: yup.string().required().label('Email address')
});

export const forgotPasswordSubmitSchema = yup.object().shape({
  code: yup.string().required().label('Code'),
  password: yup.string().required().label('Password'),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref('password')], 'Passwords do not match')
    .label('Confirm Password')
});
